/* React */
import React from "react";

/* Utils */
import ChartWrapper from "src/utils/wrapper/chart-wrapper/ChartWrapper";

/* Components */
import StackedBarchart from "src/components/charts/stacked-barchart/StackedBarchart";

/* Interfaces */
import { BarchartProps } from "src/shared/interfaces/charts/Barchart";
import { ComponentProps } from "src/shared/interfaces/common/Layout";

export const createBarchart = (
  index: number,
  label: React.ReactNode,
  data: BarchartProps[],
  legend: React.ReactNode,
  downloadFilename?: string
): ComponentProps[] => {
  return [
    {
      component: (
        <ChartWrapper
          label={label}
          legend={legend}
          downloadFilename={downloadFilename}
        >
          {(height, width) => (
            <StackedBarchart
              key={`barchart-${index}`}
              data={data}
              dimensions={{ height, width }}
            />
          )}
        </ChartWrapper>
      ),
      fullWidth: true,
    },
  ];
};
